import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyDtdZ_veaVdpZXXHjYZ-bfQPSaYBP7eSkU",
    authDomain: "go-drive-auto.firebaseapp.com",
    databaseURL: "https://go-drive-auto-default-rtdb.firebaseio.com",
    projectId: "go-drive-auto",
    storageBucket: "go-drive-auto.firebasestorage.app",
    messagingSenderId: "945848005196",
    appId: "1:945848005196:web:b2640091ca514e467d3ae9",
    measurementId: "G-FJHQPV9HG5"
  };

  
const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
export const auth = getAuth(app); // ✅
